export default function escapeHtml(string) {
    // The regex returns an array, contains the 'a', 'b', or 'i' tags with their content
    // in one group and everything else (including any occurrences of eg. <3) in the other group.
    const matches = string.match(/(<(a|b|i)[^>]*>.*?<\/\2>)|([<]*[^<]*)/g);
    const allowedTags = ['<a', '<b', '<i'];
    return matches
        .map(match => {
            if (allowedTags.some(tag => match.startsWith(tag))) {
                return match;
            }
            return match
                .replace(/&/g, '&amp;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
        })
        .join('');
}